import InvoicePreview from './invoice-preview';
import InvoicePreviewV2 from './invoice-preview-v2';
import RefundPreview from './refund-preview';
import EmailPreviewPane from './email-preview-pane';
import { GloballyAllowedSidebar } from '@atlassian/cssxp-utils-generic';
import CloudSiteSearchSidebarPane from '../../reserved-cloud-site-results/src/search-cloud-site-sidebar';
import AddNewSiteSidebarPane from '../../../account-subscriptions/cloud-site/src/sidebars/add-new-site/add-new-site';
import UnAssignReservedSiteNamePane from '../../../account-subscriptions/cloud-site/src/sidebars/assign-reserved-site-name-pane/un-assign-reserved-site-name-pane';

export const globalAllowedSidebars = {
  [GloballyAllowedSidebar.INVOICE_PREVIEW]: InvoicePreview,
  [GloballyAllowedSidebar.INVOICE_PREVIEW_V2]: InvoicePreviewV2,
  [GloballyAllowedSidebar.REFUND_PREVIEW]: RefundPreview,
  [GloballyAllowedSidebar.EMAIL_PREVIEW]: EmailPreviewPane,
  [GloballyAllowedSidebar.CLOUD_SITE_AUDIT_LOG_PREVIEW]: CloudSiteSearchSidebarPane,
  [GloballyAllowedSidebar.ADD_NEW_CLOUD_SITE]: AddNewSiteSidebarPane,
  [GloballyAllowedSidebar.UNASSIGN_CLOUD_SITE_PANE]: UnAssignReservedSiteNamePane,
};
